import { render } from "./ButtonGradientBorder.vue?vue&type=template&id=772fac12&scoped=true"
import script from "./ButtonGradientBorder.vue?vue&type=script&lang=js"
export * from "./ButtonGradientBorder.vue?vue&type=script&lang=js"

import "./ButtonGradientBorder.vue?vue&type=style&index=0&id=772fac12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772fac12"]])

export default __exports__